import { Component, Input, OnInit } from '@angular/core';
import { LocalFile } from '../../../classes';
import { FileService } from '../../../services/file.service';

@Component({
  selector: 'app-local-file-preview',
  templateUrl: './local-file-preview.component.html',
  styleUrls: ['./local-file-preview.component.css']
})
export class LocalFilePreviewComponent implements OnInit {

  icon: string;

  @Input() file: LocalFile;

  constructor(
    private _fileService: FileService
  ) { }

  ngOnInit(): void {
    this.updateValues();
  }

  updateValues(){
    this.icon = FileService.getFileType(this.file.type);
  }

}
